import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 12 16",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.82 5.82V3.64a4.37 4.37 0 00-3.86 6.4L.9 11.1a5.82 5.82 0 014.92-8.92V0l2.9 2.9-2.9 2.92zM9.67 5.96l1.06-1.06a5.82 5.82 0 01-4.92 8.92V16l-2.9-2.9 2.9-2.92v2.18a4.37 4.37 0 003.86-6.4z" })
});
export default SvgRefresh;
